import { render, staticRenderFns } from "./user-detail-dialog.vue?vue&type=template&id=028d7728&scoped=true"
import script from "./user-detail-dialog.vue?vue&type=script&lang=js"
export * from "./user-detail-dialog.vue?vue&type=script&lang=js"
import style0 from "./user-detail-dialog.vue?vue&type=style&index=0&id=028d7728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028d7728",
  null
  
)

export default component.exports